module.exports = __webpack_public_path__ + "static/media/transaction-pending.9ed249c8.svg";